import React, { useEffect } from 'react';
import { motion, useSpring, useMotionValue, useTransform } from 'framer-motion';

export default function MouseSpotlight() {
  const mouseX = useMotionValue(0);
  const mouseY = useMotionValue(0);

  const springConfig = { damping: 25, stiffness: 150 };
  const springX = useSpring(mouseX, springConfig);
  const springY = useSpring(mouseY, springConfig);

  useEffect(() => {
    const handleMouseMove = (e) => {
      mouseX.set(e.clientX);
      mouseY.set(e.clientY);
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => () => window.removeEventListener('mousemove', handleMouseMove);
  }, [mouseX, mouseY]);

  // Back to 300px radius white light
  const background = useTransform(
    [springX, springY],
    ([x, y]) => `radial-gradient(300px circle at ${x}px ${y}px, rgba(255, 255, 255, 0.08), transparent 80%)`
  );

  return (
    <motion.div
      className="fixed inset-0 pointer-events-none z-[60] hidden lg:block"
      style={{ background }}
    />
  );
}
